<template>
  <div class="left-panel">
    <!-- ==================== 数据总览模块 ==================== -->
    <div class="panel-item overview-panel">
      <div class="panel-box">
        <div class="panel-content">
          <!-- ==================== 上半部分: 标题+数据 (占 2/5) ==================== -->
          <div class="overview-top">
            <!-- 标题栏 -->
            <div class="panel-header">
              <div class="panel-title">数据总览</div>
            </div>
            
            <!-- 分割线 -->
            <div class="divider-line"></div>
            
            <!-- 活动状态提示和天数 (上下结构，居中) -->
            <div class="overview-status-row">
              <div class="overview-date-vertical">
                <div class="date-text">第五届体育云动会已开展</div>
                <div class="overview-number">
                  <div class="big-number">156</div>
                  <div class="number-label">天</div>
                </div>
              </div>
            </div>
            
            <!-- 统计数据横向排列 (4个并排) -->
            <div class="overview-stats">
              <div class="stat-item">
                <div class="stat-label">总参赛人数</div>
                <div class="stat-value">2916745</div>
              </div>
              <div class="stat-item">
                <div class="stat-label">总参赛单位数</div>
                <div class="stat-value">53789</div>
              </div>
              <div class="stat-item">
                <div class="stat-label">总关注人次</div>
                <div class="stat-value">357126846</div>
              </div>
              <div class="stat-item">
                <div class="stat-label">总会员数</div>
                <div class="stat-value">1126326</div>
              </div>
            </div>
          </div>
          
          <!-- ==================== 下半部分: 饼图 (占 3/5) ==================== -->
          <div id="pieChart" class="chart-container"></div>
        </div>
      </div>
    </div>

    <!-- ==================== 项目占比模块 ==================== -->
    <div class="panel-item project-panel">
      <div class="panel-box">
        <div class="panel-content">
          <!-- 标题栏 + 切换标签 -->
          <div class="panel-header">
            <div class="panel-title">项目占比</div>
            <div class="panel-tabs">
              <span 
                class="tab" 
                :class="{ active: projectChartType === 'participant' }"
                @click="switchProjectChartType('participant')"
              >参赛人数</span>
              <span 
                class="tab" 
                :class="{ active: projectChartType === 'attention' }"
                @click="switchProjectChartType('attention')"
              >关注人次</span>
            </div>
          </div>
          
          <!-- 分割线 -->
          <div class="divider-line"></div>
          
          <!-- 项目占比环形饼图容器 (占满剩余空间) -->
          <div id="projectChart" class="chart-container-large"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'

export default {
  name: 'LeftPanel',
  data() {
    return {
      currentSessionData: null,  // 当前届次数据
      projectChartType: 'participant',  // 项目占比图表类型: 'participant' 或 'attention'
      pieChartTimer: null,       // 联赛总览饼图轮播定时器
      pieChartIndex: 0,          // 联赛总览饼图当前高亮索引
      projectChartTimer: null,   // 项目占比饼图轮播定时器
      projectChartIndex: 0,      // 项目占比饼图当前高亮索引
      pieResizeObserver: null,   // 联赛总览饼图 ResizeObserver
      projectResizeObserver: null, // 项目占比饼图 ResizeObserver
      pieChart: null,            // 联赛总览饼图实例
      projectChart: null         // 项目占比饼图实例
    }
  },
  mounted() {
    // 使用 $nextTick 确保 DOM 已经渲染完成
    this.$nextTick(() => {
      // 页面加载完成后初始化图表
      this.initPieChart()      // 初始化联赛总览饼图
      this.initProjectChart()  // 初始化项目占比双层饼图
    })
    
    // 订阅届次切换事件
    EventBus.$on('session-changed', this.handleSessionChange)
  },
  beforeDestroy() {
    // 清除定时器
    if (this.pieChartTimer) {
      clearInterval(this.pieChartTimer)
    }
    if (this.projectChartTimer) {
      clearInterval(this.projectChartTimer)
    }
    
    // 断开 ResizeObserver 连接并清理引用
    if (this.pieResizeObserver) {
      this.pieResizeObserver.disconnect()
      this.pieResizeObserver = null
    }
    if (this.projectResizeObserver) {
      this.projectResizeObserver.disconnect()
      this.projectResizeObserver = null
    }
    
    // 销毁图表实例
    if (this.pieChart) {
      this.pieChart.dispose()
      this.pieChart = null
    }
    if (this.projectChart) {
      this.projectChart.dispose()
      this.projectChart = null
    }
    
    // 取消订阅届次切换事件，避免内存泄漏
    EventBus.$off('session-changed', this.handleSessionChange)
  },
  methods: {
    /**
     * 处理届次切换事件
     * @param {Object} payload - 事件载荷 { session: number|string, data: Object }
     */
    handleSessionChange(payload) {
      if (!payload || !payload.data) {
        console.error('届次切换事件数据无效')
        return
      }
      
      // 保存当前届次数据
      this.currentSessionData = payload.data
      
      // 更新图表数据
      this.updateCharts()
    },
    
    /**
     * 更新所有图表数据
     */
    updateCharts() {
      if (!this.currentSessionData) {
        return
      }
      
      // 更新数据总览模块
      this.updateOverviewData()
      
      // 重新渲染联赛总览饼图
      this.updatePieChart()
      
      // 重新渲染项目占比饼图
      this.updateProjectChart()
    },
    
    /**
     * 更新数据总览模块的数据
     */
    updateOverviewData() {
      const overview = this.currentSessionData.overview
      if (!overview) {
        return
      }
      
      // 检测是否为移动端
      const isMobile = window.innerWidth < 768
      
      // 更新 DOM 元素的文本内容
      // 更新天数
      const bigNumberEl = document.querySelector('.big-number')
      if (bigNumberEl) {
        bigNumberEl.textContent = overview.totalGames
      }
      
      // 更新日期文本
      const dateTextEl = document.querySelector('.date-text')
      if (dateTextEl) {
        let sessionText
        if (this.currentSessionData.session === 'all') {
          // 全部届次：显示"历届体育云动会累计开展"
          sessionText = '历届体育云动会累计开展'
        } else {
          // 单个届次：显示"第X届体育云动会已开展"
          sessionText = `第${this.getChineseNumber(this.currentSessionData.session)}届体育云动会已开展`
        }
        dateTextEl.textContent = sessionText
      }
      
      // 更新统计数据
      const statValues = document.querySelectorAll('.stat-value')
      if (statValues.length >= 4) {
        statValues[0].textContent = overview.totalParticipants.toLocaleString()
        statValues[1].textContent = overview.totalMatches.toLocaleString()
        
        // 移动端：总关注人次和总会员数转换为万为单位
        if (isMobile) {
          statValues[2].textContent = Math.round(overview.totalExercises / 10000) + '万'
          statValues[3].textContent = Math.round(overview.totalRewards / 10000) + '万'
        } else {
          statValues[2].textContent = overview.totalExercises.toLocaleString()
          statValues[3].textContent = overview.totalRewards.toLocaleString()
        }
      }
    },
    
    /**
     * 将数字转换为中文数字
     * @param {number} num - 数字
     * @returns {string} 中文数字
     */
    getChineseNumber(num) {
      const chineseNumbers = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
      return chineseNumbers[num] || num
    },
    
    /**
     * 更新联赛总览饼图
     */
    updatePieChart() {
      const projectDistribution = this.currentSessionData.projectDistribution
      if (!projectDistribution || !Array.isArray(projectDistribution)) {
        return
      }
      
      // 使用保存的图表实例
      if (!this.pieChart) {
        return
      }
      
      // 先停止轮播，避免在更新数据时触发 tooltip
      this.stopPieChartCarousel()
      
      // 准备数据 - 将字符串转换为数字，使用实际数量而不是百分比
      const data = projectDistribution.map(item => ({
        name: item.name,
        value: parseFloat(item.value) || 0,  // 百分比用于计算扇形大小
        count: parseInt(item.count) || 0      // 实际数量用于显示
      }))
      
      // 计算实际数量的总和（不是百分比）
      const total = data.reduce((sum, item) => sum + (item.count || 0), 0)
      
      // 格式化总数（添加千分位分隔符）
      const formattedTotal = total.toLocaleString()
      
      // 提取颜色
      const colors = projectDistribution.map(item => item.color)
      
      // 更新图表配置
      this.pieChart.setOption({
        color: colors,
        title: {
          subtext: formattedTotal  // 显示实际数量总和
        },
        tooltip: {
          formatter: function(params) {
            // 显示：名称 + 实际数量 + 百分比
            // 添加更严格的数据验证，防止偶发的 undefined 错误
            if (params && params.data && typeof params.data.count === 'number') {
              const count = params.data.count.toLocaleString()
              return `${params.name}<br/> ${count} (${params.percent}%)`
            }
            // 降级处理：只显示百分比
            return params && params.name ? `${params.name}: ${params.percent || 0}%` : ''
          }
        },
        legend: {
          formatter: function(name) {
            const item = data.find(d => d.name === name)
            if (!item) return name
            const count = item.count.toLocaleString()
            return '{name|' + name + '} '
          }
        },
        series: [
          {
            data: data.map(item => ({
              name: item.name,
              value: item.value,  // 使用百分比计算扇形大小
              count: item.count   // 保存实际数量用于显示
            }))
          },
          {
            data: [{ value: 1, itemStyle: { color: 'rgba(79, 172, 254, 0.2)' } }]
          },
          {
            data: [{ value: 1, itemStyle: { color: 'rgba(79, 172, 254, 0.3)' } }]
          }
        ]
      })
      
      // 数据更新完成后，延迟启动轮播，确保数据已完全渲染
      this.$nextTick(() => {
        setTimeout(() => {
          this.startPieChartCarousel()
        }, 100)
      })
    },
    
    /**
     * 启动联赛总览饼图轮播
     * 每3秒自动高亮下一个扇形
     */
    startPieChartCarousel() {
      // 停止之前的轮播
      this.stopPieChartCarousel()
      
      if (!this.pieChart) {
        return
      }
      
      const option = this.pieChart.getOption()
      if (!option || !option.series || !option.series[0] || !option.series[0].data) {
        return
      }
      
      const dataLength = option.series[0].data.length
      if (dataLength === 0) {
        return
      }
      
      // 重置索引
      this.pieChartIndex = 0
      
      // 启动定时器
      this.pieChartTimer = setInterval(() => {
        // 取消上一个高亮
        this.pieChart.dispatchAction({
          type: 'downplay',
          seriesIndex: 0,
          dataIndex: this.pieChartIndex
        })
        
        // 移动到下一个
        this.pieChartIndex = (this.pieChartIndex + 1) % dataLength
        
        // 高亮当前
        this.pieChart.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex: this.pieChartIndex
        })
        
        // 显示提示框（跟随扇形，但限制范围）
        this.pieChart.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: this.pieChartIndex
        })
      }, 3000)  // 每3秒切换一次
    },
    
    /**
     * 停止联赛总览饼图轮播
     */
    stopPieChartCarousel() {
      if (this.pieChartTimer) {
        clearInterval(this.pieChartTimer)
        this.pieChartTimer = null
      }
      
      // 取消所有高亮
      if (this.pieChart) {
        this.pieChart.dispatchAction({
          type: 'downplay',
          seriesIndex: 0
        })
      }
    },
    
    /**
     * 切换项目占比图表类型
     * @param {string} type - 'participant' 或 'attention'
     */
    switchProjectChartType(type) {
      if (this.projectChartType === type) {
        return
      }
      
      this.projectChartType = type
      this.updateProjectChart()
    },
    
    /**
     * 更新项目占比饼图
     */
    updateProjectChart() {
      const projectList = this.currentSessionData.projectList
      if (!projectList || !Array.isArray(projectList)) {
        return
      }
      
      // 使用保存的图表实例
      if (!this.projectChart) {
        return
      }
      
      // 先停止轮播，避免在更新数据时触发 tooltip
      this.stopProjectChartCarousel()
      
      // 准备数据 - 从 projectList 生成饼图数据
      const data = projectList.map(item => {
        // 根据当前选择的类型显示不同的数据
        const value = this.projectChartType === 'participant' 
          ? (parseFloat(item.percent) || 0)
          : (parseFloat(item.attention_percentage) || 0)
        
        // 实际数量
        const count = this.projectChartType === 'participant'
          ? (parseInt(item.count) || 0)
          : (parseInt(item.attention_count) || 0)
        
        return {
          name: item.name,
          value: value,
          count: count  // 添加实际数量
        }
      })
      
      // 计算实际数量的总和（不是百分比）
      const total = this.projectChartType === 'participant'
        ? projectList.reduce((sum, item) => sum + (parseInt(item.count) || 0), 0)
        : projectList.reduce((sum, item) => sum + (parseInt(item.attention_count) || 0), 0)
      
      // 格式化总数（添加千分位分隔符）
      const formattedTotal = total.toLocaleString()
      
      // 更新图表配置
      this.projectChart.setOption({
        title: {
          subtext: formattedTotal
        },
        tooltip: {
          formatter: function(params) {
            // 显示：名称 + 实际数量 + 百分比
            // 添加严格的数据验证，防止偶发的 undefined 错误
            if (params && params.data && typeof params.data.count === 'number') {
              const count = params.data.count.toLocaleString()
              return `${params.name}<br/>${count} (${params.percent}%)`
            }
            // 降级处理：只显示百分比
            return params && params.name ? `${params.name}: ${params.percent || 0}%` : ''
          }
        },
        series: [
          {
            data: data,
            label: {
              // 标签格式: 名称 + 百分比（简化显示，详细信息在 tooltip 中）
              formatter: function(params) {
                return `{b|${params.name}}\n{d|${params.percent}%}`
              },
              rich: {
                b: {
                  fontSize: 11,
                  color: 'rgba(255, 255, 255, 0.45)',
                  align: 'left',
                  padding: [2, 4]
                },
                d: {
                  fontSize: 11,
                  color: '#4facfe',
                  align: 'left',
                  padding: [2, 4],
                  fontWeight: 'bold'
                }
              }
            }
          }
        ]
      })
      
      // 数据更新完成后，延迟启动轮播，确保数据已完全渲染
      this.$nextTick(() => {
        setTimeout(() => {
          this.startProjectChartCarousel()
        }, 100)
      })
    },
    
    /**
     * 启动项目占比饼图轮播
     * 每3秒自动高亮下一个扇形
     */
    startProjectChartCarousel() {
      // 停止之前的轮播
      this.stopProjectChartCarousel()
      
      if (!this.projectChart) {
        return
      }
      
      const option = this.projectChart.getOption()
      if (!option || !option.series || !option.series[0] || !option.series[0].data) {
        return
      }
      
      const dataLength = option.series[0].data.length
      if (dataLength === 0) {
        return
      }
      
      // 重置索引
      this.projectChartIndex = 0
      
      // 启动定时器
      this.projectChartTimer = setInterval(() => {
        // 取消上一个高亮
        this.projectChart.dispatchAction({
          type: 'downplay',
          seriesIndex: 0,
          dataIndex: this.projectChartIndex
        })
        
        // 移动到下一个
        this.projectChartIndex = (this.projectChartIndex + 1) % dataLength
        
        // 高亮当前
        this.projectChart.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex: this.projectChartIndex
        })
        
        // 显示提示框（跟随扇形，但限制范围）
        this.projectChart.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: this.projectChartIndex
        })
      }, 3000)  // 每3秒切换一次
    },
    
    /**
     * 停止项目占比饼图轮播
     */
    stopProjectChartCarousel() {
      if (this.projectChartTimer) {
        clearInterval(this.projectChartTimer)
        this.projectChartTimer = null
      }
      
      // 取消所有高亮
      if (this.projectChart) {
        this.projectChart.dispatchAction({
          type: 'downplay',
          seriesIndex: 0
        })
      }
    },
    
    /**
     * 处理联赛总览饼图尺寸变化
     */
    handlePieResize() {
      if (this.pieChart) {
        this.pieChart.resize()
      }
    },
    
    /**
     * 处理项目占比饼图尺寸变化
     */
    handleProjectResize() {
      if (this.projectChart) {
        this.projectChart.resize()
      }
    },
    /**
     * 初始化联赛总览饼图
     * 特点: 三层结构 (主饼图 + 内边框 + 外边框) + 中心文字 + 右侧图例
     */
    initPieChart() {
      // 获取 DOM 元素并初始化 ECharts 实例
      this.pieChart = this.$echarts.init(document.getElementById('pieChart'))
      
      // 饼图数据 - 从后端获取
      const data = []
      
      // 检测是否为移动端
      const isMobile = window.innerWidth < 768
      
      const option = {
        // 饼图颜色方案 (8种颜色对应8个分类)
        color: ['#00d4ff', '#52c41a', '#bce672', '#ffd700', '#ff6b9d', '#bce672', '#ffa940', '#c45aec'],
        // 鼠标悬停提示框配置
        tooltip: {
          trigger: 'item',                      // 触发类型: 数据项触发
          formatter: function(params) {
            // 格式: 名称 数量 (百分比)
            // 添加严格的数据验证，防止偶发的 undefined 错误
            if (params && params.data && typeof params.data.count === 'number') {
              const count = params.data.count.toLocaleString()
              return `${params.name} ${count} (${params.percent}%)`
            }
            // 降级处理：只显示百分比
            return params && params.name ? `${params.name} ${params.percent || 0}%` : ''
          },
          backgroundColor: 'rgba(0, 0, 0, 0.7)', // 背景色
          borderColor: '#4facfe',               // 边框色
          borderWidth: 1,
          padding: [4, 8],                      // 内边距 [上下, 左右] - 缩小
          textStyle: {
            color: '#fff',                      // 文字颜色
            fontSize: 11                        // 字体大小 - 缩小
          },
          confine: true,                        // 限制在图表区域内
          position: function(point, params, dom, rect, size) {
            // 智能定位：跟随扇形但限制范围
            const x = point[0]
            const y = point[1]
            const boxWidth = size.contentSize[0]
            const boxHeight = size.contentSize[1]
            const viewWidth = size.viewSize[0]
            const viewHeight = size.viewSize[1]
            
            // 默认偏移量（较小，避免溢出）
            let posX = x + 15
            let posY = y + 15
            
            // 如果右侧空间不够，显示在左侧
            if (posX + boxWidth > viewWidth - 10) {
              posX = x - boxWidth - 15
            }
            
            // 如果下方空间不够，显示在上方
            if (posY + boxHeight > viewHeight - 10) {
              posY = y - boxHeight - 15
            }
            
            // 确保不超出边界
            posX = Math.max(10, Math.min(posX, viewWidth - boxWidth - 10))
            posY = Math.max(10, Math.min(posY, viewHeight - boxHeight - 10))
            
            return [posX, posY]
          }
        },
        // 中心文字配置 (显示在饼图中心)
        title: {
          text: '总数',                         // 主标题
          subtext: '0',                         // 副标题 (数值) - 初始为0
          textStyle: {
            color: 'rgba(255, 255, 255, 0.45)',
            fontSize: 12,
            fontWeight: 'normal'
          },
          subtextStyle: {
            fontSize: 18,                       // 数值字号
            color: '#4facfe',
            fontWeight: 'bold'
          },
          left: isMobile ? '50%' : '34.0%',    // 移动端居中，桌面端偏左
          top: '40.5%',                        // 垂直居中
          textAlign: 'center',
          textVerticalAlign: 'middle'
        },
        // 图例配置 (显示在右侧) - 问题 4: 移动端隐藏图例
        legend: {
          show: !isMobile,                      // 移动端隐藏图例
          orient: 'vertical',                   // 垂直排列
          top: 'middle',                        // 垂直居中
          right: '5%',                          // 距离右侧 5%
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          icon: 'circle',                       // 图标形状: 圆形
          itemWidth: 8,                         // 图标宽度
          itemHeight: 8,                        // 图标高度
          itemGap: 8,                          // 图例项间距
          // 自定义图例文本格式: 名称 + 数量（去掉百分比）
          formatter: function(name) {
            const item = data.find(d => d.name === name)
            if (!item) return name
            const count = item.count.toLocaleString()
            return '{name|' + name + '} {value|' + count + '}'
          },
          textStyle: {
            rich: {                             // 富文本样式
              name: {                           // 名称样式
                color: 'rgba(255, 255, 255, 0.45)',
                fontSize: 12,
                width: 75
              },
              value: {                          // 数量样式
                color: '#4facfe',
                fontSize: 12,
                fontWeight: 'bold'
              }
            }
          }
        },
        series: [
          // ========== 第一层: 主饼图 ==========
          {
            radius: isMobile ? ['40%', '65%'] : ['50%', '75%'],  // 移动端调整半径
            center: isMobile ? ['50%', '50%'] : ['35%', '50%'],  // 移动端居中
            type: 'pie',
            label: {
              show: true,                       // 显示标签
              formatter: '{b|{b}}\n{hr|}\n{d|{d}%}',    // 标签格式: 名称 + 分隔线 + 百分比 (三行显示)
              rich: {                           // 富文本样式
                b: {                            // 名称样式
                  fontSize: isMobile ? 10 : 12,
                  color: 'rgba(255, 255, 255, 0.45)',
                  align: 'left',
                  padding: 4
                },
                hr: {                           // 分隔线样式
                  borderColor: 'rgba(255, 255, 255, 0.45)',       // 青色分隔线
                  width: '100%',
                  borderWidth: 1,
                  height: 0
                },
                d: {                            // 百分比样式
                  fontSize: isMobile ? 10 : 12,
                  color: '#4facfe',             // 青色百分比
                  align: 'left',
                  padding: 4,
                  fontWeight: 'bold'
                }
              },
              fontSize: isMobile ? 10 : 12,     // 标签字号
              color: 'rgba(255, 255, 255, 0.45)',                    // 标签颜色
              position: 'outside'               // 标签位置: 外侧
            },
            labelLine: {                        // 标签引导线
              show: true,
              length: isMobile ? 5 : 10,        // 移动端缩短引导线
              length2: isMobile ? 10 : 20,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)',
                width: 1
              }
            },
            data: [],                           // 数据源 - 从后端获取
            emphasis: {                         // 鼠标悬停效果
              scale: true,                      // 启用缩放
              scaleSize: 10,                    // 缩放大小（像素）- 更明显的高亮效果
              itemStyle: {
                shadowBlur: 20,                 // 增强阴影
                shadowOffsetX: 0,
                shadowColor: 'rgba(79, 172, 254, 0.8)',
                borderColor: '#fff',            // 白色边框
                borderWidth: 2                  // 边框宽度
              }
            }
          },
          // ========== 第二层: 内边框 ==========
          {
            radius: isMobile ? ['38%', '40%'] : ['48%', '50%'],  // 移动端调整
            center: isMobile ? ['50%', '50%'] : ['35%', '50%'],  // 移动端居中
            type: 'pie',
            label: {
              show: false                       // 不显示标签
            },
            labelLine: {
              show: false                       // 不显示引导线
            },
            animation: false,                   // 关闭动画
            tooltip: {
              show: false                       // 不显示提示框
            },
            data: [
              {
                value: 1,
                itemStyle: {
                  color: 'rgba(79, 172, 254, 0.2)' // 半透明青色
                }
              }
            ]
          },
          // ========== 第三层: 外边框 ==========
          {
            type: 'pie',
            clockWise: false,                   // 逆时针
            hoverAnimation: false,              // 关闭悬停动画
            center: isMobile ? ['50%', '50%'] : ['35%', '50%'],  // 移动端居中
            radius: isMobile ? ['67%', '68%'] : ['77%', '78%'],  // 移动端调整
            label: {
              show: false
            },
            data: [
              {
                value: 1,
                itemStyle: {
                  color: 'rgba(79, 172, 254, 0.3)' // 半透明青色
                }
              }
            ]
          }
        ]
      }
      
      // 应用配置
      this.pieChart.setOption(option)
      
      // 添加 ResizeObserver 监听容器尺寸变化
      if (typeof ResizeObserver !== 'undefined') {
        // 使用防抖避免 ResizeObserver loop 错误
        let resizeTimeout = null
        this.pieResizeObserver = new ResizeObserver(() => {
          if (resizeTimeout) {
            clearTimeout(resizeTimeout)
          }
          resizeTimeout = setTimeout(() => {
            this.handlePieResize()
          }, 100)
        })
        
        const chartDom = document.getElementById('pieChart')
        if (chartDom) {
          this.pieResizeObserver.observe(chartDom)
        }
      } else {
        // 降级方案：使用 window.resize 事件
        window.addEventListener('resize', this.handlePieResize)
      }
    },
    
    /**
     * 初始化项目占比环形饼图
     * 特点: 单层环形饼图 + 中心文字 + 标签显示
     */
    initProjectChart() {
      // 获取 DOM 元素并初始化 ECharts 实例
      this.projectChart = this.$echarts.init(document.getElementById('projectChart'))
      
      const option = {
        // 饼图颜色方案 (50种鲜艳颜色 - 明显区分)
        color: [
          '#FF1493', '#FFD700', '#00FF7F', '#1E90FF', '#9370DB',
          '#FF4500', '#00FA9A', '#4169E1', '#DA70D6', '#FF69B4',
          '#FFA500', '#00FF00', '#0000FF', '#8A2BE2', '#FF1493',
          '#FF0000', '#00FFFF', '#00BFFF', '#FF6347', '#7FFFD4',
          '#FFFF00', '#BA55D3', '#87CEEB', '#FFB90F', '#32CD32',
          '#DC143C', '#00CED1', '#9932CC', '#00FA9A', '#FF8C00',
          '#FF4500', '#A9A9A9', '#2F4F4F', '#20B2AA', '#228B22',
          '#4169E1', '#9400D3', '#191970', '#FFD700', '#DC143C',
          '#F0F8FF', '#C0C0C0', '#708090', '#FF6347', '#B22222',
          '#FFAA00', '#00CED1', '#6A5ACD', '#EE82EE', '#FF0000'
        ],
        // 鼠标悬停提示框配置
        tooltip: {
          trigger: 'item',                      // 触发类型: 数据项触发
          formatter: function(params) {
            // 格式: 名称 数量 (百分比)
            // 添加严格的数据验证，防止偶发的 undefined 错误
            if (params && params.data && typeof params.data.count === 'number') {
              const count = params.data.count.toLocaleString()
              return `${params.name} ${count} (${params.percent}%)`
            }
            // 降级处理：只显示百分比
            return params && params.name ? `${params.name} ${params.percent || 0}%` : ''
          },
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          borderColor: '#4facfe',
          borderWidth: 1,
          padding: [4, 8],                      // 内边距 [上下, 左右] - 缩小
          textStyle: {
            color: '#fff',
            fontSize: 11                        // 字体大小 - 缩小
          },
          confine: true,                        // 限制在图表区域内
          position: function(point, params, dom, rect, size) {
            // 固定提示框位置，避免溢出
            const x = point[0]
            const y = point[1]
            const boxWidth = size.contentSize[0]
            const boxHeight = size.contentSize[1]
            const viewWidth = size.viewSize[0]
            const viewHeight = size.viewSize[1]
            
            let posX = x + 10
            let posY = y + 10
            
            // 如果右侧空间不够，显示在左侧
            if (posX + boxWidth > viewWidth) {
              posX = x - boxWidth - 10
            }
            
            // 如果下方空间不够，显示在上方
            if (posY + boxHeight > viewHeight) {
              posY = y - boxHeight - 10
            }
            
            // 确保不超出边界
            posX = Math.max(10, Math.min(posX, viewWidth - boxWidth - 10))
            posY = Math.max(10, Math.min(posY, viewHeight - boxHeight - 10))
            
            return [posX, posY]
          }
        },
        // 中心文字配置 (显示在饼图中心)
        title: {
          text: '总数',                         // 主标题
          subtext: '0',                         // 副标题 (总数值) - 初始为0
          textStyle: {
            color: 'rgba(255, 255, 255, 0.45)',
            fontSize: 12,
            fontWeight: 'normal'
          },
          subtextStyle: {
            fontSize: 18,                       // 数值字号
            color: '#4facfe',
            fontWeight: 'bold'
          },
          left: '49.0%',                          // 水平居中
          top: '44%',                           // 垂直居中
          textAlign: 'center',
          textVerticalAlign: 'middle'
        },
        legend: {
          show: false                           // 不显示图例 (数据已在标签中显示)
        },
        series: [
          // ========== 环形饼图 (带标签) ==========
          {
            type: 'pie',
            radius: ['35%', '55%'],             // 半径: 45%-75% (环形)
            center: ['50%', '50%'],             // 中心点: 完全居中
            label: {
              // 标签格式: 名称 + 分隔线 + 百分比 (三行显示)
              formatter: '{b|{b}}\n{hr|}\n{d|{d}%}',
              rich: {                           // 富文本样式
                b: {                            // 名称样式
                  fontSize: 12,
                  color: 'rgba(255, 255, 255, 0.45)',
                  align: 'left',
                  padding: 4
                },
                hr: {                           // 分隔线样式
                  borderColor: 'rgba(255, 255, 255, 0.45)',       // 青色分隔线
                  width: '100%',
                  borderWidth: 1,
                  height: 0
                },
                d: {                            // 百分比样式
                  fontSize: 12,
                  color: '#4facfe',             // 青色百分比
                  align: 'left',
                  padding: 4,
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {                        // 标签引导线
              show: true,
              length: 15,                       // 第一段线长度
              length2: 20,                      // 第二段线长度
              lineStyle: {
                type: 'dashed',                 // 虚线样式
                width: 1,
                color: 'rgba(255, 255, 255, 0.3)'
              }
            },
            data: [],                           // 数据源 - 从后端获取
            emphasis: {                         // 高亮效果
              scale: true,                      // 启用缩放
              scaleSize: 10,                    // 缩放大小（像素）- 更明显的高亮效果
              itemStyle: {
                shadowBlur: 20,                 // 增强阴影
                shadowOffsetX: 0,
                shadowColor: 'rgba(79, 172, 254, 0.8)',
                borderColor: '#fff',            // 白色边框
                borderWidth: 2                  // 边框宽度
              }
            }
          }
        ]
      }
      
      // 应用配置
      this.projectChart.setOption(option)
      
      // 添加 ResizeObserver 监听容器尺寸变化
      if (typeof ResizeObserver !== 'undefined') {
        // 使用防抖避免 ResizeObserver loop 错误
        let resizeTimeout = null
        this.projectResizeObserver = new ResizeObserver(() => {
          if (resizeTimeout) {
            clearTimeout(resizeTimeout)
          }
          resizeTimeout = setTimeout(() => {
            this.handleProjectResize()
          }, 100)
        })
        
        const chartDom = document.getElementById('projectChart')
        if (chartDom) {
          this.projectResizeObserver.observe(chartDom)
        }
      } else {
        // 降级方案：使用 window.resize 事件
        window.addEventListener('resize', this.handleProjectResize)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.left-panel {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.panel-item {
  flex: 1;
  
  &.overview-panel {
    flex: 0 0 50%;  // 数据总览模块固定占 50% 高度
  }
  
  &.project-panel {
    flex: 0 0 50%;  // 项目占比模块固定占 50% 高度
    
    .panel-box {
      background: url('~@/assets/images/项目占比的背景图.png') no-repeat center center;
      background-size: 100% 100%;
    }
  }
}

.panel-box {
  width: 100%;
  height: 100%;
  background: url('~@/assets/images/数据总览模块的背景图.png') no-repeat center center;
  background-size: 100% 100%;
  border-radius: 4px;
  position: relative;
}

.panel-content {
  padding: 1.5vh 0vh;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  background: url('~@/assets/images/tyu.png') no-repeat;
  background-position: right 2.8vh;
  overflow: hidden;  // 隐藏溢出内容，防止出现滚动条
}

.overview-top {
  flex: 2;  // 上半部分占 2/5
  display: flex;
  flex-direction: column;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  flex-wrap: nowrap;
  z-index: 1;
  padding: 1vh 1vh 0.5vh 2vh;
  background: url('~@/assets/images/标题背景.png') no-repeat center center;
  background-size: 100% 100%;
  border-radius: 0px;
  margin-top: 0vh;
}

.panel-title {
  font-size: 16px;
  font-weight: bold;
  color: #E2E2E2;
  position: relative;
  padding-left: 12px;
  
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 16px;
    background: linear-gradient(to bottom, #4facfe, #00f2fe);
    border-radius: 2px;
  }
}

.divider-line {
  width: 100%;
  height: 2px;
  background: url('~@/assets/images/分割线.png') no-repeat center center;
  background-size: 100% 100%;
}

.overview-status-row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom:0.5vh;
  margin-top: 1vh;
}

.overview-date-vertical {
  margin-top: 0vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  width: 100%;
}

.date-text {
  font-size: 14px;
  color: #8c8c8c;
  text-align: center;
}

.overview-number {
  display: flex;
  align-items: baseline;
  gap: 5px;
  padding: 0px 50px;
  background: url('~@/assets/images/组 9521.png') no-repeat center center;
  background-size: 100% 100%;
  border-radius: 4px;
  
  .big-number {
    font-size: 3.6vh;
    font-weight: bold;
    color: #67BFF3;
    line-height: 1;
    text-shadow: 0 0 15px rgba(79, 172, 254, 0.6);
  }
  
  .number-label {
    font-size: 14px;
    color: #8c8c8c;
  }
}

.panel-tabs {
  display: flex;
  gap: 8px;
  margin-right: 5.5vh;
  
  .tab {
    padding: 0.3vh 1.6vh;
    font-size: 12px;
    color: #8c8c8c;
    cursor: pointer;
    border: 1px solid rgba(79, 172, 254, 0.3);
    border-radius: 15px;
    transition: all 0.3s;
    background: transparent;
    position: relative;
    overflow: hidden;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(79, 172, 254, 0.2), transparent);
      transition: left 0.5s;
    }
    
    &.active {
      color: #fff;
      border-color: #4facfe;
      background: transparent;
      box-shadow: 0 0 10px rgba(79, 172, 254, 0.5);
      font-weight: bold;
      
      &::before {
        left: 100%;
      }
    }
    
    &:hover:not(.active) {
      color: #4facfe;
      border-color: #4facfe;
      background: transparent;
    }
  }
}

.overview-stats {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 0vh;  // 推到底部
  padding-bottom: 0.5vh;
  background: url('~@/assets/images/uuu.png') no-repeat center bottom;
  background-size: contain;
}

.stat-item {
  flex: 1;
  text-align: center;
  padding: 0.5vh 0.5vh;
  background: transparent;
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  .stat-label {
    font-size: 12px;
    color: #8c8c8c;
    margin-bottom: 0.5vh;
    white-space: nowrap;
  }
  
  .stat-value {
    font-size: 2vh;
    font-weight: bold;
    color: #67BFF3;
    line-height: 1.2;
  }
}

.chart-container {
  width: 100%;
  flex: 3;  // 下半部分占 3/5
  min-height: 0;  // 允许 flex 收缩
  overflow: hidden;  // 隐藏溢出内容
}

.chart-container-large {
  width: 100%;
  flex: 1;
  min-height: 0;  // 允许 flex 收缩
  overflow: hidden;  // 隐藏溢出内容
}

// 移动端样式优化
@media (max-width: 767px) {
  .panel-item {
    &.overview-panel {
      flex: 0 0 auto;  // 自动高度
      min-height: 450px;
    }

    &.project-panel {
      flex: 0 0 auto;  // 自动高度
      min-height: 400px;
    }
  }

  .chart-container {
    min-height: 250px;  // 确保图表有足够的高度
    height: 250px;
  }

  .chart-container-large {
    min-height: 300px;  // 确保图表有足够的高度
    height: 300px;
  }

  .panel-content {
    padding: 10px;
  }

  .panel-title {
    font-size: 14px;
  }

  // 问题 1: 统计数据优化 - 防止撑出屏幕
  .overview-stats {
    gap: 5px;  // 减小间距
    padding: 0 5px;
  }

  .stat-item {
    padding: 5px 2px;
    min-width: 0;  // 允许收缩
  }

  .stat-label {
    font-size: 10px;  // 减小字体
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .stat-value {
    font-size: 14px;  // 减小字体
    white-space: nowrap;  // 不换行
    overflow: hidden;
    text-overflow: ellipsis;  // 超出显示省略号
  }

  // 问题 3: 切换按钮样式优化 - 降低高度
  .panel-tabs {
    gap: 6px;
    margin-right: 30px;

    .tab {
      padding: 4px 10px;
      font-size: 11px;
      border-radius: 10px;
      background: rgba(15, 45, 75, 0.6);
      border: 1px solid rgba(79, 172, 254, 0.4);
      min-height: 28px;
      display: flex;
      align-items: center;
      
      &.active {
        background: linear-gradient(135deg, rgba(79, 172, 254, 0.3), rgba(0, 242, 254, 0.3));
        border-color: #4facfe;
        box-shadow: 0 0 8px rgba(79, 172, 254, 0.4);
      }
    }
  }

  // 问题 4: 移动端隐藏饼图右侧图例
  .chart-container,
  .chart-container-large {
    // 图例将通过 ECharts 配置隐藏
  }
}
</style>
